"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownFilterButton = void 0;
var React = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var styles = _interopRequireWildcard(require("./styles.css"));
var _uiKit = require("@cian/ui-kit");
var _FilterWrapper = require("../FilterWrapper");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/** Компонент для кнопки в строке фильтров, которая открывает дропдаун */
const DropdownFilterButton = exports.DropdownFilterButton = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    isEmpty,
    isActive,
    testId,
    handleToggle,
    isFirstFilter,
    isLastFilter,
    label
  } = props;
  return /*#__PURE__*/React.createElement(_FilterWrapper.FilterWrapper, {
    isLastFilter: isLastFilter,
    isFirstFilter: isFirstFilter
  }, /*#__PURE__*/React.createElement("button", {
    ref: ref,
    type: "button",
    className: (0, _classnames.default)(styles['control-button'], isActive && styles['control-button--active'], isEmpty && styles['control-button--empty']),
    onClick: handleToggle,
    "data-testid": `${testId}_control`
  }, /*#__PURE__*/React.createElement(_uiKit.UIText2, {
    color: "current_color"
  }, label)));
});
DropdownFilterButton.displayName = 'DropdownFilterButton';